import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/pro-solid-svg-icons';

import Tooltip from 'components/tooltip';

export default function CompanyOfficeRow({ companyOffice, showOfficeName, onEdit }) {
  const {
    name, invoiceIdentifierPrefix, nextInvoiceNumber,
    backofficeInvoicePaymentInstructions, backofficeInvoiceNotes
  } = companyOffice;

  function renderWithTooltip(content) {
    return (
      <Tooltip content={content} onlyOnOverflow>
        {content}
      </Tooltip>
    );
  }

  function renderEmptyState(textPlacement) {
    return (
      <em className="text-muted">
        Included at the {textPlacement} of each invoice
      </em>
    );
  }

  return (
    <tr>
      {showOfficeName && <td name="office-name-cell">{name}</td>}
      <td>{invoiceIdentifierPrefix || 'None'}</td>
      <td>{nextInvoiceNumber || '1'}</td>
      <td className="text-truncate" style={{ maxWidth: 240 }}>
        {backofficeInvoicePaymentInstructions
          ? renderWithTooltip(backofficeInvoicePaymentInstructions)
          : renderEmptyState('top')
        }
      </td>
      <td className="text-truncate" style={{ maxWidth: 280 }}>
        {backofficeInvoiceNotes
          ? renderWithTooltip(backofficeInvoiceNotes)
          : renderEmptyState('bottom')
        }
      </td>
      <td className="sticky-cell end-cell">
        <div className="clickable" name="edit" onClick={() => onEdit(companyOffice)}>
          <FontAwesomeIcon icon={faEdit} />
          <span className="ms-1">Edit</span>
        </div>
      </td>
    </tr>
  );
}

CompanyOfficeRow.propTypes = {
  companyOffice: PropTypes.shape({
    backofficeInvoiceNotes: PropTypes.string,
    backofficeInvoicePaymentInstructions: PropTypes.string,
    invoiceIdentifierPrefix: PropTypes.string,
    name: PropTypes.string,
    nextInvoiceNumber: PropTypes.number,
  }),
  showOfficeName: PropTypes.bool,
  onEdit: PropTypes.func.isRequired,
};
